import React, { useState, useRef, useEffect } from "react";
import TextField from "@mui/material/TextField";
import {
  Box,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  Tooltip,
} from "@mui/material";
import FindReplaceIcon from "@mui/icons-material/FindReplace";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
interface GoogleLocationSearchProps {
  onSelectLocation?: (place: google.maps.places.PlaceResult) => void;
  selectedActualAddress?: any;
  setSelectedActualAddress?: any;
  setSelectedLocation?: any;
}

const SearchAutoComplete: React.FC<GoogleLocationSearchProps> = ({
  setSelectedLocation,
  selectedActualAddress,
  setSelectedActualAddress,
}) => {
  const [predictions, setPredictions] = useState<
    google.maps.places.AutocompletePrediction[]
  >([]);

  const inputRef = useRef<HTMLInputElement>(null);
  const autocompleteServiceRef =
    useRef<google.maps.places.AutocompleteService | null>(null);

  useEffect(() => {
    // Ensure that the Google Maps JavaScript API is loaded
    if (!autocompleteServiceRef.current && window.google) {
      autocompleteServiceRef.current =
        new window.google.maps.places.AutocompleteService();
    }
  }, []);

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedActualAddress(e.target.value);

    if (e.target.value && autocompleteServiceRef.current) {
      // Fetch place predictions
      autocompleteServiceRef.current.getPlacePredictions(
        { input: e.target.value },
        (predictions) => {
          if (predictions) {
            setPredictions(predictions);
          } else {
            setPredictions([]);
          }
        }
      );
    } else {
      setPredictions([]);
    }
  };

  const handlePredictionClick = (placeId: string, description: string) => {
    setSelectedActualAddress(description); // Set the selected input value
    setPredictions([]); // Clear the dropdown

    const placesService = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );

    // Get more details about the selected place using the placeId
    placesService.getDetails(
      { placeId },
      (
        place: google.maps.places.PlaceResult | null,
        status: google.maps.places.PlacesServiceStatus
      ) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && place) {
          //   setSelectedLocation(place);
          if (place.geometry?.location) {
            const lat = place?.geometry?.location?.lat();
            const lng = place?.geometry?.location?.lng();
            // Pass the lat and lng to the parent component using setSelectedLocation
            if (setSelectedLocation) {
              setSelectedLocation({
                lat: Number(lat),
                lng: Number(lng),
              });
            }
          }
        }
      }
    );
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <TextField
        inputRef={inputRef}
        value={selectedActualAddress}
        onChange={handleInputChange}
        label="DELIVERY AREA"
        placeholder="Search Location"
        variant="outlined"
        fullWidth
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {selectedActualAddress && (
                <Tooltip title="Clear Text Field">
                  <IconButton
                    sx={{ padding: 0 }}
                    onClick={() => setSelectedActualAddress("")}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              )}
              <IconButton sx={{ padding: 0 }} disabled>
                <FindReplaceIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {/* Display predictions in a dropdown */}
      {predictions?.length > 0 && (
        <List
          sx={{
            position: "absolute",
            zIndex: 1000,
            top: "100%",
            left: 0,
            right: 0,
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "4px",
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {predictions?.map((prediction) => (
            <ListItem
              sx={{
                borderBorrom: "1px solid #ccc",
              }}
              key={prediction.place_id}
              button
              onClick={() =>
                handlePredictionClick(
                  prediction.place_id,
                  prediction.description
                )
              }
            >
              <span style={{ marginRight: 10 }}>
                {" "}
                <LocationOnIcon color="error" fontSize="small" />
              </span>
              {prediction.description}
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};

export default SearchAutoComplete;
